import {Model} from "./";
import {Api} from "../api";

class DeliveryModel extends Model {

    constructor() {
        super(new Api("/delivery"));
    }

    getTypes(paymentId,thenFunction, errorFunction) {
        this.q.setDopUrl('/types/'+paymentId);
        this.q.read({}, thenFunction, errorFunction);
    }

    getDates(PointsId,DeliveryType,thenFunction, errorFunction) {
        this.q.setDopUrl('/dates/'+PointsId+'?type='+DeliveryType);
        this.q.read({}, thenFunction, errorFunction);
    }

    getPoints(clientId,thenFunction, errorFunction) {
        this.q.setDopUrl('/points/'+clientId);
        this.q.read({}, thenFunction, errorFunction);
    }

    getAccountability(thenFunction, errorFunction) {
        this.q.setDopUrl('/accountability/');
        this.q.read({}, thenFunction, errorFunction);
    }



}

export default new DeliveryModel();